export class LocalGuarda{
    id;
    descricao: string;
    identificador: string;
    dataCadastro: string;
    ativo: string;
    idEmpresa: number;
}